export default __webpack_public_path__ + "static/media/yawo-logo.45086173.svg";